import { MAX_TOTAL_HP } from "@meleeroyale/sim";
import { useEffect } from "react";
import { backToLobby } from "../app/store.ts";
import { damageTaken } from "../arena/damage-numbers.ts";
import { accentFor } from "../arena/palette.ts";
import { Badge, Icon } from "../components/ui/index.tsx";
import { fmt, t } from "../i18n/index.ts";
import type { GameClient } from "../net/game-client.ts";

export function Results({ client, nickname }: { client: GameClient; nickname: string }) {
  const view = client.view(performance.now());
  useEffect(() => () => client.close(), [client]);
  if (!view) return null;
  const winner = view.fighters.find((f) => f.id === view.winner);
  const iWon = view.winner === view.myId;
  const rows = [...view.fighters].sort(
    (a, b) => Number(b.alive) - Number(a.alive) || total(b.hp) - total(a.hp),
  );
  return (
    <main className="shell">
      <div className="shell-center stack stack-6">
        <header className="lobby-hero stack stack-3">
          <Icon name="trophy" />
          <h1>
            {iWon
              ? t.results.youWin
              : winner
                ? fmt(t.results.winner, { name: winner.nickname })
                : t.results.noWinner}
          </h1>
          <p className="muted">
            {view.winner >= 0
              ? view.fighters.filter((f) => f.alive).length <= 1
                ? t.results.reasonLastStanding
                : t.results.reasonTimeout
              : ""}
          </p>
        </header>
        <section className="card stack stack-4">
          <h2>{t.results.title}</h2>
          <div className="results-list">
            {rows.map((f, i) => (
              <div key={f.id} className={`results-row${f.id === view.myId ? " is-me" : ""}`}>
                <span className="num muted">{i + 1}</span>
                <span className="results-name">
                  <span>
                    <span className="swatch" style={{ background: accentFor(f.id) }} />
                    {f.nickname}
                    {f.id === view.myId ? ` (${t.results.you})` : ""}
                  </span>
                  <span className="results-meta num">
                    {fmt(t.results.damage, {
                      dealt: Math.round(f.damageDealt),
                      taken: Math.round(damageTaken(f.hp)),
                    })}
                  </span>
                </span>
                {f.alive ? (
                  <Badge kind="ok">
                    <span className="num">{Math.round((total(f.hp) / MAX_TOTAL_HP) * 100)}%</span>{" "}
                    {t.results.health}
                  </Badge>
                ) : (
                  <Badge kind="danger">{t.results.out}</Badge>
                )}
              </div>
            ))}
          </div>
          <button
            type="button"
            className="btn btn-primary btn-lg btn-block"
            onClick={() => backToLobby()}
          >
            {t.results.playAgain}
          </button>
        </section>
        <p className="muted caps">{nickname}</p>
      </div>
    </main>
  );
}

function total(hp: number[]): number {
  let s = 0;
  for (const h of hp) s += h;
  return s;
}
